import request from '@/utils/request'
const qs = require('qs')

// 订单详情
export function getOrder (data) {
  return request({
    url: '/ooh-order/v1/orderopen/getorder',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 根据订单获取产品下资源明细分页
export function getOrderResourcePage (data) {
  return request({
    url: '/ooh-order/v1/orderopen/getpage',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取订单内站点数量统计 按站点分组
export function getOrderResourceCount (data) {
  return request({
    url: '/ooh-order/v1/orderopen/getresourcecount',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取订单内产品数量统计 按站点分组
export function getProductQuantity (data) {
  return request({
    url: '/ooh-order/v1/orderopen/getproductquantity',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取公司城市
export function getCompanyCityCode (data) {
  return request({
    url: '/ooh-os/v1/open/getcompanycitycode',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取公司详情
export function getCompanyById (data) {
  return request({
    url: '/ooh-os/v1/open/getcompany',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取站内售出的媒介资源
export function getSoldResourceInfo (data) {
  return request({
    url: '/ooh-order/v1/orderopen/getsoldresourceinfo',
    method: 'post',
    data: qs.stringify(data)
  })
}
